import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { FunctionalModalStyle } from "../../../../../../common/constants/custom-style";
import { RemoveMapping } from "../../../../../../domain/models/remove-mapping";
import { CustomerDatabaseStore } from "../../../../../../store/main/CustomerDatabaseStore";
import { TerritoryDataStore } from "../../../../../../store/main/TerritoryDataStore";
import { CustomerDetails } from "../../../../../../domain/models/customer-database/customer-details";
import Actions from "../../../../../../common/enums/Actions";
import Swal from "sweetalert2";
import React from "react";
import CustomerTypeID from "../../../../../../common/constants/CustomerTypeID";

interface Props {
  open: boolean;
  handleClose: Function;
  title: string;
  button: string;
  customer_id?: number;
  customer_data?: {
    headquarter_id: number;
    headquarter_code: string;
    mapping_id: number;
    sub_name: string;
  };
  customerDetails?: CustomerDetails;
  reasonOptions: string[];
  setOpenProgressBarModal: Function;
  setOpenFailedTransferModal: Function;
}
type formField = {
  customers: number[];
  reasonSelect: string;
  reason: string;
  department: string;
  team: string;
};

const CustomerActionsModal: React.FC<Props> = ({
  open,
  handleClose,
  title,
  button,
  reasonOptions,
  customer_id,
  customer_data,
  customerDetails = {} as CustomerDetails,
  setOpenProgressBarModal,
  setOpenFailedTransferModal,
}) => {
  const {
    removeCustomerMapping,
    customerIds,
    mappingIds,
    deactivateCustomer,
    fetchCustomerData,
    fetchCustomerSummaryCount,
    handleClearSelectedCustomers,
    setProgressCount,
    setTitle,
    filterStore,
    headquarterIds,
    clearFailedDeactivates,
  } = CustomerDatabaseStore();

  const { headquarterMasterData, customerTypesData, teamData } =
    TerritoryDataStore();

  const { departmentData } = TerritoryDataStore();

  const { handleSubmit, control, setValue, watch } = useForm<formField>({
    mode: "onChange",
  });

  async function deactivateCustomerProgress(
    customer_ids: number[],
    reason: string,
    data: RemoveMapping,
    index = 0
  ) {
    const headquarterCode = headquarterMasterData.find(
      (item) => item.id.toString() === filterStore.headquarter_ids[0]
    );
    const customerSubName = customerTypesData.find(
      (item) => item.id === filterStore.customer_type_id
    );
    if (customer_ids.length == 1) {
      let payload = {
        customer_id: customerIds[index],
        mapping_id: mappingIds[index],
        team_id: filterStore.team_id,
        customer_sub_name: customerSubName?.sub_name,
        department_code: watch("department"),
        headquarter_code: headquarterCode?.ga_code
          ? headquarterCode?.ga_code
          : filterStore.headquarter_code,
        headquarter_id: filterStore.headquarter_ids[0]
          ? filterStore.headquarter_ids[0]
          : headquarterIds[0],
        reason: reason,
      };
      let result = await deactivateCustomer(payload, customer_ids[index], true);
      if (result.success) {
        Swal.fire({
          icon: "success",
          timer: 4000,
          title: "Customers Deactivated Successfully",
          customClass: {
            container: "swal2-style",
          },
          confirmButtonColor: "#3085d6",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Customer Deactivation Failed",
          text: result.errors.message ? result.errors.message : result.message,
          customClass: {
            container: "swal2-style",
          },
          confirmButtonColor: "#3085d6",
        });
      }
    } else {
      let payload = {
        customer_id: customerIds[index],
        mapping_id: mappingIds[index],
        team_id: filterStore.team_id,
        customer_sub_name: customerSubName?.sub_name,
        department_code: watch("department"),
        headquarter_code: headquarterCode?.ga_code,
        headquarter_id: filterStore.headquarter_ids[0]
          ? filterStore.headquarter_ids[0]
          : headquarterIds[0],
        reason: reason,
      };
      if (index < customer_ids.length) {
        setProgressCount(index);
        setTitle("Deactivate");
        setOpenProgressBarModal(true);
        await deactivateCustomer(payload, customer_ids[index], false);
        await deactivateCustomerProgress(customer_ids, reason, data, index + 1);
      } else {
        setOpenFailedTransferModal(true);
        setOpenProgressBarModal(false);
      }
    }
  }
  const RemoveMappingCall = async (data: RemoveMapping) => {
    if (button === "Remove Mapping") {
      let payload = {
        customer_ids: [customer_id],
        reason: data.reasonSelect === "Other" ? data.reason : data.reasonSelect,
      };
      removeCustomerMapping(
        payload,
        handleClose,
        title,
        fetchCustomerData,
        handleClearSelectedCustomers
      );
    } else if (button === "Deactivate") {
      clearFailedDeactivates();
      deactivateCustomerProgress(
        customerIds,
        data.reasonSelect == "Other" ? data.reason : data.reasonSelect,
        data
      )
        .then(() => {
          handleClose(title);
          handleClearSelectedCustomers();
          fetchCustomerSummaryCount(
            CustomerDatabaseStore.getState().filterStore
          );
          fetchCustomerData();
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            timer: 3000,
            text: "Unknown Error Occured! Try Again",
            customClass: {
              container: "swal2-style",
            },
            confirmButtonColor: "#3085d6",
          });
        });
    } else if (button === "Reject Customer") {
      let payload = {
        customer_id: customer_id,
        mapping_id: customer_data?.mapping_id,
        team_id: watch("team"),
        customer_sub_name: customer_data?.sub_name,
        department_code: watch("department"),
        headquarter_code: customer_data?.headquarter_code,
        headquarter_id: customer_data?.headquarter_id,
        reason: data.reasonSelect === "Other" ? data.reason : data.reasonSelect,
      };
      let result = await deactivateCustomer(payload, customerIds[0], true);
      if (result.success) {
        Swal.fire({
          icon: "success",
          timer: 4000,
          title: "Customers Rejected",
          customClass: {
            container: "swal2-style",
          },
          confirmButtonColor: "#3085d6",
        });
        handleClearSelectedCustomers();
        fetchCustomerSummaryCount(CustomerDatabaseStore.getState().filterStore);
        fetchCustomerData();
        handleClose(title);
      } else {
        Swal.fire({
          icon: "error",
          title: "Customer Rejection Failed",
          text: result.errors.message ? result.errors.message : result.message,
          customClass: {
            container: "swal2-style",
          },
          confirmButtonColor: "#3085d6",
        });
      }
    }

    handleClose(title);
  };

  useEffect(() => {
    setValue("reason", "");
    setValue("department", "");
    setValue("reasonSelect", "");
    setValue("team", "");
  }, [open]);

  return (
    <>
      <Modal open={open}>
        <Box sx={FunctionalModalStyle}>
          <Stack gap={2}>
            <Typography
              textAlign="center"
              variant="h6"
              fontFamily="Segoe UI"
              fontWeight={600}
              color="#4D4D4D"
            >
              {title}
            </Typography>
            {title === Actions.REJECT_CUSTOMER && (
              <Controller
                name="team"
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <FormControl fullWidth size="small">
                    <InputLabel>Team</InputLabel>
                    <Select
                      value={value}
                      size="small"
                      label="Team "
                      onChange={onChange}
                    >
                      {teamData?.map((name) => (
                        <MenuItem value={name.id}>{name.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                rules={{
                  required: { value: true, message: "Team must be selected" },
                }}
              />
            )}
            <Controller
              name="department"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <FormControl fullWidth size="small">
                  <InputLabel>Select Department</InputLabel>
                  <Select
                    value={value}
                    size="small"
                    label="Select Department"
                    onChange={onChange}
                  >
                    {departmentData?.map((name) => (
                      <MenuItem value={name.code}>{name.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              rules={{
                required: { value: true, message: "Field required" },
              }}
            />
            <Controller
              name="reasonSelect"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <FormControl fullWidth size="small">
                  <InputLabel>Reason</InputLabel>
                  <Select
                    value={value}
                    size="small"
                    label="Reason"
                    onChange={onChange}
                  >
                    {reasonOptions?.map((name) => (
                      <MenuItem value={name}>{name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              rules={{
                required: { value: true, message: "There must be a Reason" },
              }}
            />
            {watch("reasonSelect") === "Other" && (
              <Controller
                name="reason"
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <TextField
                    fullWidth
                    value={value}
                    size="small"
                    onChange={onChange}
                    placeholder="Please type reason..."
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
                rules={{
                  pattern: {
                    value: /^(?!.*[^a-zA-Z0-9 ]).{5,}$/,
                    message:
                      "Enter valid reason.  No special characters and minimum 5 characters",
                  },
                }}
              />
            )}

            <Stack direction="row" gap={3} justifyContent="center">
              <Button
                disabled={
                  !(
                    (watch("reasonSelect") &&
                      watch("reasonSelect") != "Other") ||
                    (watch("reasonSelect") === "Other" &&
                      watch("reason") &&
                      watch("reason").length > 4)
                  )
                }
                variant="contained"
                color="error"
                sx={{
                  textTransform: "unset",
                  borderRadius: "30px",
                  height: "40px",
                  bgcolor: "#EF5466",
                  minWidth: "30%",
                }}
                onClick={handleSubmit(RemoveMappingCall)}
              >
                <Typography
                  variant="subtitle2"
                  fontFamily="Segoe UI"
                  color="white"
                >
                  {button}
                </Typography>
              </Button>
              <Button
                variant="outlined"
                sx={{
                  textTransform: "unset",
                  borderRadius: "30px",
                  minWidth: "30%",
                }}
                onClick={() => handleClose(title)}
              >
                <Typography variant="subtitle2" fontFamily="Segoe UI">
                  Cancel
                </Typography>
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default CustomerActionsModal;
